import { TFunction } from 'i18next'
import TokenDatabaseRestService from '../rest/TokenDatabaseRestService'

class TokenDatabaseService {
  static async getTokenDatabase() {
    return TokenDatabaseRestService.getTokenDatabase()
  }

  static async isActivated(): Promise<boolean> {
    try {
      const isActivated = await TokenDatabaseRestService.isActivated()
      return isActivated
    } catch (error) {
      return false
    }
  }

  static async updateTokenDatabase(databaseConfigInfo: any, oldConfig: any, t: TFunction, setTokenDatabase: React.Dispatch<any>) {
    try {
      const trimmedDatabaseConfigInfo = JSON.parse(
        JSON.stringify(databaseConfigInfo, function replacer(_key, value) {
          // Filtering out properties
          if (typeof value === 'string') {
            return value.trim()
          }
          return value
        })
      )
      if (trimmedDatabaseConfigInfo.password === '<Protected>') {
        trimmedDatabaseConfigInfo.password = oldConfig.password
      }
      const updatedLicense = await TokenDatabaseRestService.updateTokenDatabase(trimmedDatabaseConfigInfo)
      setTokenDatabase(updatedLicense)
      return t('tokenDatabase.UpdatedSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default TokenDatabaseService
